import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import ModalComponent from '../ui/Modal';

const PasswordSchema = Yup.object().shape({
  password: Yup.string().required('This field is required')
});

const mapStateToProps = state => ({
  errors: state.Global.errors
});

class PasswordConfirmationComponent extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  submitForm = null;

  bindSubmitForm = (submitForm) => { this.submitForm = submitForm; }
  handleFormSubmit = (e) => {
    if (this.submitForm) {
      this.setState({ isSubmitting: true });
      this.submitForm(e);
    }
  }
  onSubmit = (values) => {
    this.props.onSubmit(values);
  }

  renderBody(bindSubmitForm, onSubmit, error) {
    return (<div>
      <div className="col-12">
        <Formik
          validationSchema={PasswordSchema}
          onSubmit={onSubmit}>
          {({ errors, touched, submitForm }) => {
            bindSubmitForm(submitForm);
            return (<Form>
              <Field
                name="password"
                type="password"
                placeholder="Password"
                className={(errors.firstName && touched.firstName) ? "form-control error-input" : "form-control"} />
              <ErrorMessage name="password" component="div" className="error-message" />
              {error && (<div className="error-message">{error.message}</div>)}
            </Form>);
          }}
        </Formik>
      </div>
    </div>)
  }

  renderButtonRow(onClose) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col text-center pl-0">
          <label onClick={onClose}>Cancel</label>
        </div>
        <div className="col text=center">
          <button className='btn btn-primary' onClick={this.handleFormSubmit} >Sign In</button>
        </div>
      </div>
    )
  }

  render() {
    let { onClose, errType, errors } = this.props;
    let error = (errType && errors) ? errors.find(e => e.errType === errType) : null;
    return (<ModalComponent
      id="PasswordConfirmationModal"
      title="Super Admin Login"
      body={this.renderBody(this.bindSubmitForm, this.onSubmit, error)}
      footer={this.renderButtonRow(onClose)}
      noMinHeight={true}
      onClose={onClose} />
    );
  }
}

export default connect(mapStateToProps)(PasswordConfirmationComponent);
